
































import Vue from 'vue';

export default Vue.extend({
  name: 'Result',
  props: ['response', 'isResponseErrorOccured', 'shows'],
  computed: {
    responseText() {
      if (this.response === null) {
        return '';
      }
      try {
        return JSON.stringify(this.response, undefined, 4);
      } catch (e) {
        return this.response;
      }
    },
  },
});
